export const MATCHING_CREATIVE_MEDIA_TYPES_ERROR =
  "Both creatives must be both images or both videos.\n To use a different media type, create another ad.";

type MediaType = "image" | "video";

export type GuidedCreativeMediaValue = {
  squareMediaUrl?: string | null;
  squareMediaFileKey?: string | null;
  squareMediaType?: MediaType | null;
  verticalMediaUrl?: string | null;
  verticalMediaFileKey?: string | null;
  verticalMediaType?: MediaType | null;
};

function hasSlotAsset(url?: string | null, fileKey?: string | null): boolean {
  return Boolean(url || fileKey);
}

function getSlotMediaType(
  url: string | null | undefined,
  fileKey: string | null | undefined,
  mediaType: MediaType | null | undefined
): MediaType | null {
  if (!hasSlotAsset(url, fileKey)) return null;
  if (!mediaType) return null;
  return mediaType;
}

export function hasMixedGuidedCreativeMediaTypes(
  value: GuidedCreativeMediaValue | null | undefined
): boolean {
  const squareType = getSlotMediaType(
    value?.squareMediaUrl,
    value?.squareMediaFileKey,
    value?.squareMediaType
  );
  const verticalType = getSlotMediaType(
    value?.verticalMediaUrl,
    value?.verticalMediaFileKey,
    value?.verticalMediaType
  );
  return Boolean(squareType && verticalType && squareType !== verticalType);
}
